import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from "react";
import ValOrDash from "../../../components/ValOrDash";
import { Spin } from "antd";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import { CurrencyFormat } from "../../../components/FormattersTS";
import HelpLabel from "../../../components/HelpLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill } from '@fortawesome/free-solid-svg-icons/faMoneyBill';
const CostPerDeliveryWidget = (props, exportedRef) => {
    const [stateLoading, setStateLoading] = useState(false);
    const [stateData, setStateData] = useState(null);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     loadDeliveryExpenses()
    // }, []);
    // useEffect(() => {
    //     if (props.date) {
    //         loadDeliveryExpenses();
    //     }
    // }, [props.date]);
    const refresh = () => {
        loadDeliveryExpenses();
    };
    const loadDeliveryExpenses = () => {
        setStateLoading(true);
        axios.get(`/admin/v1/dashboard/${props.slug}/${props.date}`)
            .then(response => {
            setStateData(response.data);
        }).catch(error => {
            setStateData(null);
            axiosErrorHandler(error);
        }).finally(() => {
            setStateLoading(false);
        });
    };
    const { averageCostPerDelivery, distanceKm, costPerKm } = stateData ?? {};
    return (_jsx(Spin, { spinning: stateLoading, children: _jsxs("div", { className: "widget", children: [_jsx("div", { className: "widget-icon widget-icon-dk-blue", children: _jsx(FontAwesomeIcon, { icon: faMoneyBill }) }), _jsx("h2", { className: "widget-value", children: averageCostPerDelivery
                        ? _jsx(CurrencyFormat, { value: averageCostPerDelivery })
                        : _jsx(_Fragment, { children: "\u2014" }) }), _jsx("p", { children: _jsx(HelpLabel, { title: props.labelText, helpText: props.helpText }) }), _jsx("div", { className: "widget-separator" }), _jsxs("h2", { className: "widget-value", children: [_jsx(ValOrDash, { val: distanceKm }), "\u00A0/\u00A0", costPerKm
                            ? _jsx(CurrencyFormat, { value: costPerKm })
                            : _jsx(_Fragment, { children: "\u2014" })] }), _jsx("p", { children: _jsx(HelpLabel, { title: "Km / Cost per Km", helpText: _jsx("p", { children: "The cost per Km is calculated by dividing the above total average cost by the total number of Km's the driver is expected to travel. The Km required is determined using the google maps travel time of each delivery." }) }) })] }) }));
};
export default React.forwardRef(CostPerDeliveryWidget);
